import { render, staticRenderFns } from "./PolicyDetailAddModal.vue?vue&type=template&id=afdb8408&scoped=true&"
import script from "./PolicyDetailAddModal.vue?vue&type=script&lang=js&"
export * from "./PolicyDetailAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb8408",
  null
  
)

export default component.exports